/* global globalThis */
import {useCallback, useEffect, useState} from 'react';
import {Platform, View} from 'react-native';

import sy from '~/styles';
import {Dialog, Text} from '~/components/controls';
import ErrorIcon from '~/images/md-icons/error/materialicons/24px.svg';
import PropTypes from 'prop-types';

const DuplicateWarningDialog = ({visible, onDismiss, onOverride}) => {
  const [showOverride, setShowOverride] = useState(false);

  const keyListener = useCallback(async (e) => {
    if (e.keyCode === 73 && e.ctrlKey && e.shiftKey) {
      setShowOverride(true);
    }
  }, []);

  useEffect(() => {
    if (Platform.OS === 'web') {
      globalThis.addEventListener('keydown', keyListener);
    }
  }, [keyListener]);

  return (
    <Dialog
      visible={visible}
      title="Al aanvraag op kenteken"
      titleIcon={<ErrorIcon fill="#B3261E" />}
      onDismiss={onDismiss}
      buttons={
        showOverride
          ? [
              {
                text: 'Melding negeren',
                onPress: onOverride,
              },
              {
                text: 'OK',
                onPress: onDismiss,
              },
            ]
          : null
      }>
      <View style={[sy['flex-row'], sy['py-4']]}>
        <Text>Er staat al een aanvraag open op dit kenteken</Text>
      </View>
    </Dialog>
  );
};
DuplicateWarningDialog.propTypes = {
  visible: PropTypes.any,
  onDismiss: PropTypes.any,
  onOverride: PropTypes.any,
};

export default DuplicateWarningDialog;
